/* eslint-disable */
import isMocked from '../../lib/isMocked';
import isQABot from '../../lib/isQABot';

const ieVersion = (() => {
  let rv = null;
  if (navigator.appName === 'Microsoft Internet Explorer') {
    let ua = navigator.userAgent;
    let re = new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})');
    if (re.exec(ua) != null) rv = parseFloat(RegExp.$1);
  } else if (navigator.appName === 'Netscape') {
    let ua = navigator.userAgent;
    let re = new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})');
    if (re.exec(ua) != null) rv = parseFloat(RegExp.$1);
  }

  return rv;
})();

let isAlreadyInDOM = false;

const addFullstory = () => {
  if (
    process.env.NODE_ENV !== 'production' ||
    isQABot() ||
    isAlreadyInDOM ||
    isMocked()
  )
    return;
  if (ieVersion && ieVersion < 11) return;

  try {
    const isInIframe = window !== window?.parent;

    if (isInIframe) {
      window['_fs_run_in_iframe'] = true;
    }
    window['_fs_debug'] = false;
    window['_fs_host'] = 'fullstory.com';
    window['_fs_script'] = 'edge.fullstory.com/s/fs.js';
    window['_fs_org'] = 'PYEV';
    window['_fs_namespace'] = isInIframe ? 'FullStory' : 'FS';
    (function (m, n, e, t, l, o, g, y) {
      if (e in m) {
        if (m.console && m.console.log) {
          m.console.log(
            'FullStory namespace conflict. Please set window["_fs_namespace"].'
          );
        }
        return;
      }
      g = m[e] = function (a, b, s) {
        g.q ? g.q.push([a, b, s]) : g._api(a, b, s);
      };
      g.q = [];
      o = n.createElement(t);
      o.async = 1;
      o.crossOrigin = 'anonymous';
      o.src = 'https://' + window._fs_script;
      y = n.getElementsByTagName(t)[0];
      y.parentNode.insertBefore(o, y);
      g.identify = function (i, v, s) {
        g(l, { uid: i }, s);
        if (v) g(l, v, s);
      };
      g.setUserVars = function (v, s) {
        g(l, v, s);
      };
      g.event = function (i, v, s) {
        g('event', { n: i, p: v }, s);
      };
      g.anonymize = function () {
        g.identify(!!0);
      };
      g.shutdown = function () {
        g('rec', !1);
      };
      g.restart = function () {
        g('rec', !0);
      };
      g.log = function (a, b) {
        g('log', [a, b]);
      };
      g.consent = function (a) {
        g('consent', !arguments.length || a);
      };
      g.identifyAccount = function (i, v) {
        o = 'account';
        v = v || {};
        v.acctId = i;
        g(o, v);
      };
      g.clearUserCookie = function () {};
      g._w = {};
      y = 'XMLHttpRequest';
      g._w[y] = m[y];
      y = 'fetch';
      g._w[y] = m[y];
      if (m[y])
        m[y] = function () {
          return g._w[y].apply(this, arguments);
        };
      g._v = '1.2.0';
    })(window, document, window['_fs_namespace'], 'script', 'user');
    isAlreadyInDOM = true;
  } catch (e) {
    console.error('addFullstory errors', e);
  }
};

export default addFullstory;
